import React, { useState, useEffect, useCallback } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import SubmissionError from '../../components/SubmissionError'
import CustomModal from '../../components/CustomModal'
import { useHistory } from "react-router-dom"
import { services } from '../../services'
import { ReactComponent as BackButton } from "../../assets/icons/ui/BackButton.svg"
import { ReactComponent as EmptyState } from '../../assets/icons/inventory/NoAccount.svg'

const ReferenceAccount = require('../../assets/icons/inventory/Streetlight.svg')
const MasterAccount = require('../../assets/icons/inventory/MasterAccount.svg')
const AddNew = require('../../assets/icons/map/Plus.svg')
const RightArrow = require('../../assets/icons/inventory/RightArrow.svg')
const Electric = require('../../assets/icons/inventory/Electric.svg')
const Gas = require('../../assets/icons/inventory/Gas.svg')
const Combined = require('../../assets/icons/inventory/Combined.svg')
const Spinner = require('../../assets/icons/ui/loader.gif')

const { api } = services 

const InventoryAccountlist = (props) => {
  const history = useHistory()
  const [finalData, setFinalData] = useState('')
  const [totalAccounts, setTotalAccounts] = useState('')
  const [loading, setLoading] = useState(true)
  const [, setNoCloseIcon] = useState(false)
  const [isErrorModal,setIsErrorModal] = useState(false)
  const [isErrorModalStyle,setIsErrorModalStyle] = useState(false)
  const [closeIconStatus, setCloseIconStatus] = useState(true)

  const { onMount } = props
  
  useEffect(() => {
    onMount(true)
    AccountListData()
    return () => {
      onMount(false)
    }
    // eslint-disable-next-line
  }, [])

  const AccountListData = useCallback(() =>{
    api.AccountListData()
      .then((response) => {
        setFinalData(response.data.Accounts)
        setTotalAccounts(response.data.TotalAccounts)
        setLoading(false)
      }, (error) =>{
        if(error.response === undefined){
          setNoCloseIcon(false)
          setIsErrorModalStyle(false)
          setIsErrorModal(false)
        }
        else{
          setNoCloseIcon(true)
          setIsErrorModalStyle(true)
          setIsErrorModal(true)
        }
      })
    return () => {
     
    }
  },[])

 
  const modalToggle = () => {
    setNoCloseIcon(false)
    setIsErrorModalStyle(false)
    setIsErrorModal(false)
  }
  const noCloseIconOnModal = () => {
    setCloseIconStatus(true)
  }

  const handleAddAccount = (e) => {
    window.open(process.env.REACT_APP_ADD_ACCOUNT_URL, "_blank")
  }

  const handleClick = (event, selectedAccount) => {
    let finalArray = []
    finalArray.push(selectedAccount)
    if(selectedAccount.accountType.codeString === '54'){
      history.push({
        pathname: '/InventoryAccount/InventoryReport',
        state: { ReferenceInfo: finalArray , AccountList :finalArray},
      })
    }else{
      history.push({
        pathname: '/InventoryAccount/InventoryReferenceInfo',
        state: { AccountList: finalArray },
      })
    }
    props.setSavedState(finalArray)
  }

  const renderBody = () => {
    if(finalData === [] || totalAccounts === 0){  
      return <div className='NoAccountList'>
        <EmptyState className='NoAccountList-Icon'/>
        <p className='NoLinked-Account'>No Linked Accounts</p>
        <p className='NoAccountList-content'>You have no accounts currently added to your profile. Please add an account to your profile to view inventory</p>
      </div>
    }
    else if(finalData !== undefined && finalData !== [] && finalData !== '' && totalAccounts !== 0){
      return ( finalData && finalData.map((data,index) => {
        return ( <Card key ={index} className='masterAccountCard'>
          <div className='masterAccount-info-card'>
            <section className='masterAccount-Rowinfo'>
              <li className='masterAccount-li'>
                <span className='masterAccount-body-iconText'>
                  {data.isStreetLight === 'true' && data.isOnSummaryBill === false
                  && data.accountType.codeString === '51'
                    ?
                    <img src={MasterAccount} alt='Master Bill Account' title='Master Bill Account' aria-label='Master Bill Account' />
                    :
                    data.isStreetLight === true
                     && data.accountType.codeString === '54'
                      ?
                      <img src={ReferenceAccount} alt='Reference Number' title='Reference Number' aria-label='Reference Number' />
                      :
                      data.Servicetype === 'Electricity'  && data.isStreetLight === false ?
                        <img src={Electric} alt='Electricity' aria-label='Electricity' />
                        :
                        data.Servicetype === 'Gas' && data.isStreetLight === false ?
                          <img src={Gas} alt="Gas" aria-label='Gas'/>
                          :
                          data.Servicetype === 'Electricity and Gas' && data.isStreetLight === false &&
                          <img src={Combined} alt="Electricity and Gas" aria-label='Electricity and Gas' />
                  }
                </span>
              </li>
              <li className='masterAccount-li'>
                <span className='masterAccount-body-firstcolumn'>
                  {data.billAccountNumber}
                </span>
              </li>
              <li className='masterAccount-li' >
                <div className='masterAccount-body-secondcolumn'>
                  {data.serviceAddressCompressed}
                </div>
              </li>
            </section>
            <section className='masterAccount-body-button'>
              <li className='masterAccount-li'>
                {data.isStreetLight === true ? <Button
                  className="-primary reportselect"
                  aria-label={`Select Account`}
                  data-a11y-focus="first"
                  onClick={e => handleClick(e, data)}
                >
                    Select Account
                </Button>
                  :
                  <p className='notEligible'>
                      Not a Streetlight Account
                  </p>
                }
              </li>
            </section>
            <li className='masterAccount-li' >
              <section className='masterAccount-body-icon'>
                <img src={RightArrow} alt='>' onClick={e => handleClick(e, data)} />
              </section>
            </li>
          </div>
        </Card>
        )
      })
      )
    }
  }

  return (
    <div className='masterAccount-full-card' data-test='InvAccountComponent'>
      <div className='masterAccount-title' data-test='InvAccountContent'>
        <h1 className='masterAccount-heading'> Choose an Account</h1>
        <Button
          className={`-secondary addNewAccount`}
          aria-label={`Add Account`}
          data-a11y-focus="first"
          onClick={e => handleAddAccount(e)}
        >
          <span className='masterAccount-AddIcon'><img src={AddNew} alt="+" /></span>
          <span className='masterAccount-AddText'>Add Account</span>
        </Button>
        {isErrorModal && isErrorModalStyle
          ? <CustomModal
            modalContent={ 
              <SubmissionError
                noCloseIcon={noCloseIconOnModal}
                onclickOpen={modalToggle}
                setIsErrorModalStyle={setIsErrorModalStyle}
                tryagainClick={AccountListData}
              /> }
            onclickOpen={modalToggle}
            isShowContent={true}
            hideCloseIcon={closeIconStatus}
            noCloseIcon={noCloseIconOnModal}
            isErrorModalStyle={isErrorModalStyle}
            setIsErrorModalStyle={setIsErrorModalStyle}
          /> : null}
      </div>
      {finalData !== undefined && finalData !== [] && finalData !== '' && totalAccounts !== 0 ?<Card className="masterAccount-header-card">
        <div className='masterAccount-headerRow'>
          <span className='masterAccount-header-firstcolumn'>
            Account
          </span>
          <span >
            Address
          </span>
        </div>
      </Card>
        :
        ''
      }
      {loading ? 
        <div className="loading-spinner"> 
          <img src={Spinner} className ="spinner-alignment" alt="Icon"/>
          <span className="loading-message">Loading .....</span>
          <span>Please wait while we load your data</span>
        </div>
        :
        renderBody()
      } 
      <section className="inventory-cancel-actions">
        <Button
          className={`-secondary inventorycancel`}
          aria-label={`Cancel and return to homepage`}
          data-a11y-focus="first"
          onClick={() => history.push('/')}
        >
          Cancel
        </Button>
        <Button
          className={`button -link-button-back -secondary back`}
          aria-label={`Back`}
          data-a11y-focus="first"
          onClick={() => history.push('/')}
        >
          <BackButton/>
        </Button>
      </section>
    </div>
  )
}
export default InventoryAccountlist
